import { useQuery } from '@tanstack/react-query';
import queryString from 'query-string';

import { MENU_TYPE } from '~features/home/constants';
import { fetcher } from '~lib/api/fetch';
import type { SalaryRank, ViewRank } from '~types/ranking';

import QueryKeys from '../queryKeys';

type RankingResponse = {
  version: string;
  data: (SalaryRank | ViewRank)[];
};

const rankingUrlList: { [key in MENU_TYPE]: string } = {
  DALIY_VIEW_RANK: '/api/main/viewsRank',
  SALARY_RANK: '/api/main/salaryRank',
  PUBLIC_SALARY_RANK: '/api/main/salaryRank',
  RECENT_SALARY_RANK: '/api/main/salaryRank',
};

const CHUNK_SIZE = 10;
const LIST_LIMIT = 30;

const convertData = (data: (SalaryRank | ViewRank)[] | undefined) => {
  const rankingData = (data || []).slice(0, LIST_LIMIT);

  const mappedRankingData = rankingData
    .map((e, i) => (i % CHUNK_SIZE === 0 ? rankingData.slice(i, i + CHUNK_SIZE) : null))
    .filter((e) => e);

  return mappedRankingData;
};

export default function useGetRanking(selectedMenu: MENU_TYPE, sectionCode?: string) {
  const queryParams: Record<string, string> = {};
  if (
    (selectedMenu === 'DALIY_VIEW_RANK' || selectedMenu === 'SALARY_RANK') &&
    sectionCode &&
    sectionCode !== 'TOTAL'
  ) {
    queryParams['sectionCode'] = sectionCode;
  }

  if (selectedMenu === 'PUBLIC_SALARY_RANK') {
    queryParams['category'] = 'PUBLIC';
  }

  if (selectedMenu === 'RECENT_SALARY_RANK') {
    queryParams['category'] = 'HIRED';
  }

  const response = useQuery<RankingResponse>(
    [QueryKeys.rankingList, selectedMenu, sectionCode],
    () => fetcher(`${rankingUrlList[selectedMenu]}?${queryString.stringify(queryParams)}`),
    {
      enabled: !!selectedMenu,
    },
  );

  const { data, status } = response;

  return {
    status,
    data,
    mappedData: convertData(data?.data),
  };
}
